import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import hideToasts from 'devextreme/ui/toast/hide_toasts';

@Injectable({providedIn: 'root'})
export class NotificationService {
	private position = 'bottom center';
	private direction = 'up-push';
	constructor() { }

	show(message?: string, type?: string) {
		const position: any = this.position;
		const direction: any = this.direction;
		notify({
			message: message,
			height: 45,
			width: 300,
			minWidth: 150,
			type: type,
			displayTime: 3500,
			animation: {
				show: {
				type: 'fade', duration: 400, from: 0, to: 1,
				},
				hide: { type: 'fade', duration: 40, to: 0 },
			},
			},
			{ position, direction });
	}
}
